import React, { useState, useEffect } from "react";
import "./RegisterCalculator.scss";
import { BallClipRotate } from "react-pure-loaders";
import { getToken, getSimulation, getConfiguration } from "../../services/api.js";
import cookie from "react-cookies";
import { momentEs } from "../../services/moment";
import { withRouter, Link } from "react-router-dom";
import { PopInformation } from "../register/PopInformation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { currencyFormatter, decimalFormatter } from "../../utils/format";
import Slider from "../calculator/Slider";
import Button from "../common/Button";
// import { faTable, faDownload } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const idProduct = 4;

const RegisterCalculator = ({ proposalChange = {}, props }) => {
  const [open, setOpen] = useState(false);
  const [monto, setMonto] = useState(null);
  const [firstPaymentAmount, setFirstPaymentAmount] = useState(null);
  const [plazo, setPlazo] = useState(null);
  const [periodicidad, setPeriodicidad] = useState(3);
  const [cat, setCat] = useState(null);
  const [interesIVA, setInteresIVA] = useState(null);
  const [commision, setCommision] = useState(0);
  const [fecha, setFecha] = useState(null);
  const [registerData, setRegisterData] = useState(null);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [amortizationTable, setAmortizationTable] = useState([]);
  const [serverError, setServerError] = useState(false);

  let today = new Date();
  let idClient = 0;

  const simulate = async (amount, freq, term) => {
    let validToken = await cookie.load("token");
    if (!validToken) {
      let response = await getToken();
      if (!response.data) return props.push("/error");
      if (response.data) validToken = response.data.token;
    }
    getSimulation(idProduct, amount, freq, term, idClient, validToken)
      .then((res) => {
        const { data } = res;
        if (res.status === 200) {
          setCat(data.cat);
          setInteresIVA(data.interest);
          setFirstPaymentAmount(data.firstPaymentAmount);
          setFecha(data.firstDueDate);
          setLoading(false);
          setAmortizationTable(data.amortizationTable);
          setCommision(data.commision);
        }
      })
      .catch((err) => console.log(err));
  };

  const updateMonto = (val) => {
    setMonto(val);
  };

  const updatePlazo = (val) => {
    setPlazo(val);
  };

  // const updatePeriodicidad = val => {
  //     if(val === 2){
  //         if(plazo > 6) setPlazo(6)
  //     }
  //     if(val === 1){
  //         if(plazo < 4) setPlazo(4)
  //     }
  //     setPeriodicidad(val)
  // }

  const getInitConfig = async () => {
    let validToken = await cookie.load("token");
    if (!validToken) {
      let response = await getToken();
      if (!response.data) return props.push("/error");
      if (response.data) validToken = response.data.token;
    }
    getConfiguration(idProduct, validToken)
      .then((res) => {
        const { data } = res;
        if (res.status === 200) {
          let config = {
            minAmount: data.minAmount,
            maxAmount: data.maxAmount > 2000 ? 2000 : data.maxAmount,
            stepAmount: data.stepAmount,
            minTermSem: data.frequencies[0].frequencyTerm.minTerm,
            maxTermSem: data.frequencies[0].frequencyTerm.maxTerm,
            minTermQuin: data.frequencies[1] ? data.frequencies[1].frequencyTerm.minTerm : 0,
            maxTermQuin: data.frequencies[1] ? data.frequencies[1].frequencyTerm.maxTerm : 0,
          };
          setRegisterData({ sliderConfig: config });
          setMonto(data.defaultAmount > 2000 ? 2000 : data.defaultAmount);
          const realTerm = data.frequencies[0].frequencyTerm.defaultValue;
          setPlazo(realTerm);
          simulate(data.defaultAmount > 2000 ? 2000 : data.defaultAmount, 3, realTerm);
          sessionStorage.setItem(
            "proposal",
            JSON.stringify({
              idProduct,
              monto: data.defaultAmount > 2000 ? 2000 : data.defaultAmount,
              periodicidad: 3,
              plazo: realTerm,
            })
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const calcConfig = async () => {
    let validToken = await cookie.load("token");
    if (!validToken) {
      let response = await getToken();
      if (!response.data) return props.push("/error");
      if (response.data) validToken = response.data.token;
    }
    getConfiguration(idProduct, validToken)
      .then((res) => {
        const { data } = res;
        if (res.status === 200) {
          let config = {
            minAmount: data.minAmount,
            maxAmount: data.maxAmount > 2000 ? 2000 : data.maxAmount,
            stepAmount: data.stepAmount,
            minTermSem: data.frequencies[0].frequencyTerm.minTerm,
            maxTermSem: data.frequencies[0].frequencyTerm.maxTerm,
            minTermQuin: data.frequencies[1] ? data.frequencies[1].frequencyTerm.minTerm : 0,
            maxTermQuin: data.frequencies[1] ? data.frequencies[1].frequencyTerm.maxTerm : 0,
          };
          setRegisterData({ sliderConfig: config });
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const loadConfig = async () => {
      let response = await getToken();
      if (!response.data) return setServerError(true);
      let getLocalProposal = await JSON.parse(sessionStorage.getItem("proposal"));
      if (!getLocalProposal) return getInitConfig();
      calcConfig();
      setMonto(getLocalProposal.monto > 2000 ? 2000 : getLocalProposal.monto);
      setPlazo(getLocalProposal.plazo);
      setPeriodicidad(getLocalProposal.periodicidad);
      return simulate(getLocalProposal.monto > 2000 ? 2000 : getLocalProposal.monto, getLocalProposal.periodicidad, getLocalProposal.plazo);
    };
    loadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading && registerData) {
      simulate(monto, periodicidad, plazo);
      sessionStorage.setItem("proposal", JSON.stringify({ monto, periodicidad, plazo, idProduct }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monto, periodicidad, plazo]);

  useEffect(() => {
    if (proposalChange) {
      setMonto(proposalChange.monto);
      setPlazo(process.env.REACT_APP_SITE === "mivivus" ? 15 : proposalChange.plazo);
      setPeriodicidad(proposalChange.periodicidad);
      simulate(proposalChange.monto, proposalChange.periodicidad, process.env.REACT_APP_SITE === "mivivus" ? 15 : proposalChange.plazo);
      sessionStorage.setItem(
        "proposal",
        JSON.stringify({
          monto: proposalChange.monto,
          periodicidad: proposalChange.periodicidad,
          plazo: proposalChange.plazo,
          idProduct,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposalChange]);

  let stepWidth = 25;
  return (
    <>
      {serverError ? (
        <div className="lg:rounded-lg lg:mt-12 self-start overflow-hidden bg-green-light flex flex-col shadow-sm h-auto lg:max-w-xl text-sm w-full py-4 lg:px-4 px-2 gap-4">
          <div className="bg-white rounded-xl shadow-sm flex justify-center items-center flex-col py-4 px-4 lg:px-8 xl:pb-8 xl:pt-4 gap-4">
            <FontAwesomeIcon icon={faExclamationTriangle} className="text-green-primary text-2xl" />
            <h2 className="text-center text-xl">Servidor no disponible, intenta más tarde.</h2>
          </div>
        </div>
      ) : !loading && registerData ? (
        <div className="lg:rounded-lg lg:mt-12 self-start overflow-hidden bg-green-light flex flex-col shadow-sm h-auto lg:max-w-xl text-sm w-full py-4 lg:px-4 px-2 gap-4">
          <div className="bg-white rounded-xl shadow-sm flex justify-center items-center flex-col py-4 px-4 lg:px-8  gap-4">
            <div className="flex items-center w-full justify-between">
              <div className="flex flex-col text-black-primary">
                <h2 className="text-xl font-extra-bold">Resumen del préstamo</h2>
              </div>

              <Link className="text-blue-primary hover:text-blue-light active:text-blue-dark font-bold font-xl transition-all" onClick={() => setEdit(!edit)}>
                {edit ? "Actualizar" : "Editar"}
              </Link>
            </div>
          </div>
          {edit && (
            <>
              <div className="bg-white rounded-xl shadow-sm flex justify-center items-center flex-col py-4 px-4 lg:px-8 xl:pb-8 xl:pt-4 gap-4">
                <div className="w-full flex flex-col">
                  <div className="flex justify-space w-full justify-between items-center">
                    <p className="text-black-primary font-bold text-lg">Monto total</p>
                    <span className="text-green-primary text-lg font-bold">${decimalFormatter.format(monto)}</span>
                  </div>
                  <Slider config={registerData.sliderConfig} min={registerData.sliderConfig.minAmount} max={registerData.sliderConfig.maxAmount} step={registerData.sliderConfig.stepAmount} value={monto} labelFormatter={currencyFormatter} update={updateMonto} />
                  {monto > 2000 && <div className="w-full text-gray-600 mt-6 bg-white p-2 text-xs text-center rounded-md transition-all font-bold">¿Eres cliente nuevo y necesitas un monto mayor a $2,000? Aumenta el límite en tu próximo préstamo.</div>}
                </div>
              </div>
              {process.env.REACT_APP_SITE !== "mivivus" && (
                <div className="bg-white rounded-xl shadow-sm flex justify-center items-center flex-col py-4 px-4 lg:px-8 xl:pb-8 xl:pt-4 gap-4">
                  <div className="w-full">
                    <div className="flex justify-space w-full justify-between items-center">
                      <p className="text-black-primary font-bold text-lg">Plazo</p>
                      <span className="text-green-primary text-xl font-bold">{plazo} días</span>
                    </div>
                    <Slider
                      config={registerData.sliderConfig}
                      min={registerData.sliderConfig !== "error" ? (periodicidad === 2 ? registerData.sliderConfig.minTermQuin : registerData.sliderConfig.minTermSem) : 0}
                      max={registerData.sliderConfig !== "error" ? (periodicidad === 2 ? registerData.sliderConfig.maxTermQuin : registerData.sliderConfig.maxTermSem) : 0}
                      step={1}
                      value={plazo}
                      labelFormatter={decimalFormatter}
                      legendFormatter={"días"}
                      update={updatePlazo}
                      // validSimulate={validSimulate}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-2 lg:gap-y-2 lg:gap-x-8">
            {!edit && (
              <>
                <div className="flex justify-between py-3 items-center">
                  <p>Préstamo</p>
                  <span className="text-green-primary font-bold">
                    {monto.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                    <small> MXN</small>
                  </span>
                </div>
                {process.env.REACT_APP_SITE !== "mivivus" && (
                  <>
                    <div className="flex justify-between py-3 items-center">
                      <p>Plazo</p>
                      <span className="text-green-primary font-bold">
                        {plazo} {periodicidad === 2 ? "días" : "días"}
                      </span>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-2 lg:gap-y-2 lg:gap-x-8">
            <div className="flex items-center justify-between py-2">
              <p>Interés</p>
              <div>
                <span className="text-green-primary font-bold">
                  {interesIVA.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                  <small> MXN</small>
                </span>
                <p className="text-xs text-right">IVA incluído</p>
              </div>
            </div>

            <div className="flex items-center justify-between py-2 lg:col-start-1">
              <p className="text-left w-1/2">Comisiones</p>
              <div>
                <span className="text-green-primary font-bold">
                  {commision.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                  <small> MXN</small>
                </span>
                <p className="text-right text-xs">IVA incluído</p>
              </div>
            </div>

            <div className="flex items-center justify-between py-2 lg:col-start-2 lg:row-start-1">
              <p>Monto a pagar</p>
              <div>
                <span className="text-green-primary font-bold">
                  {firstPaymentAmount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                  <small> MXN</small>
                </span>
                <p className="text-right text-xs">IVA incluído</p>
              </div>
            </div>

            <div className="flex items-center justify-between pt-2 pb-4 lg:col-start-2 lg:row-start-2">
              <p className="text-left">{process.env.REACT_APP_SITE === "mivivus" ? "Fecha de pago" : "Fecha de pago"}</p>
              <span className="text-green-primary font-bold">
                <strong>{momentEs(fecha).format("D/MMM/Y")}</strong>
              </span>
            </div>
            {/* <div className="text-xs text-left py-4">
              <b>CAT: {cat}%</b> promedio sin IVA para fines informativos y de comparación exclusivamente. <br />
              Fecha de cálculo: {momentEs(today).format("D/MMM/Y")}
              <br />
              <br />
              Calculadora para fines informativos y de comparación. <br />
              <br />
              Nunca solicitamos anticipos, cuotas, pago de pólizas o cualquier otro concepto para otorgarte un préstamo.
            </div> */}
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-4">
              <h3 className="font-bold text-xl"> Para calificar, necesitas</h3>
              <ul className="flex flex-col gap-2">
                <li className="text-md flex gap-4 items-center">
                  <img src="/img/bulletCheck.svg" width={24} alt="bullet" />
                  <span>Ser de nacionalidad mexicana.</span>
                </li>
                <li className="text-md flex gap-4 items-center">
                  <img src="/img/bulletCheck.svg" width={24} alt="bullet" />
                  <span>Ser mayor de 18 años.</span>
                </li>
                <li className="text-md flex gap-4 items-center">
                  <img src="/img/bulletCheck.svg" width={24} alt="bullet" />
                  <span>Indicar una cuenta bancaria a tu nombre para recibir tu dinero.</span>
                </li>
                <li className="text-md flex gap-4 items-center">
                  <img src="/img/bulletCheck.svg" width={24} alt="bullet" />
                  <span>Tener un teléfono celular y una cuenta de correo electrónico.</span>
                </li>
              </ul>
            </div>
            <div className="flex justify-center items-center py-4">
              <img src="/img/digicert.png" alt="digicert" />
            </div>
            <div className="flex justify-center items-center py-2">
              <Link className="text-blue-primary hover:text-blue-light active:text-blue-dark font-bold transition-all" to="/contenido/aviso-de-privacidad">
                Aviso de privacidad
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="lg:rounded-lg lg:mt-12 overflow-hidden bg-green-light flex flex-col shadow-sm h-auto lg:max-w-xl text-sm w-full py-4 lg:px-4 px-2 gap-4 self-start">
          <div className="bg-white rounded-xl shadow-sm flex justify-center items-center flex-col py-4 px-4 lg:px-8 xl:pb-8 xl:pt-4 gap-4">
            <BallClipRotate loading color={"#56AF31"} />
            <h2 className="text-center text-xl">Cargando datos...</h2>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(RegisterCalculator);
